import { jsx as _jsx } from "react/jsx-runtime";
import { ReactSVG } from 'react-svg';
import iconOrder from '../../Images/icon/eco-bag.svg';
export function YoOrder() {
    return (_jsx(ReactSVG, { src: iconOrder, className: "icon" }));
}
